module.exports = __webpack_public_path__ + "static/media/KITs.65cc9580.jpg";